export enum DenialLetterUploadStatus {
  NOT_INITIATED = "",
  INITIATED = "initiated",
  IN_PROGRESS = "in_progress",
  LETTER_NOT_FOUND = "letter_not_found",
  NOT_APPLICABLE = "na",
  NA = "na",
  COMPLETED = "completed",
  SUCCESS = "success",
  FAILED = "failed",
  ERROR = "error",
}
